const TWILIO_CONVERSATION_ID = /^CH[0-9a-fA-F]{32}$/;

/**
 * Whether a conversation id names a Twilio conversation, which is always an
 * inquiry, so no request is needed to route it.
 *
 * An id that is not Twilio's is a UUID and does not say what it is: a support
 * thread and an inquiry served natively by the API look alike. Those are told
 * apart by asking the API, in `useConversationKind`.
 */
export function isTwilioConversationId(id: string | null | undefined): id is string {
  return typeof id === 'string' && TWILIO_CONVERSATION_ID.test(id);
}
